<template>
  <div class="appointment-canceled-view row pb-5 text-primary">
    <loading-overlay v-if="loading"/>

    <div v-else class="col-12 text-center">
      <template v-if="canceled">
        <p class="mt-4 small font-weight-bold">
          {{ $t('appointment_canceled.success_title') }}
        </p>

        <div class="mb-4 font-weight-normal">
          {{ $t('appointment_canceled.success_info') }}
        </div>

        <a class="btn btn-lg btn-primary btn-block my-4 action-button" @click.prevent="bookAnotherAppointment">
          {{ $t('appointment_canceled.book_again') }}
        </a>
      </template>

      <template v-else>
        <p class="mt-4 small font-weight-bold">
          {{ $t('appointment_canceled.confirm_title') }}
        </p>

        <div class="mb-4 font-weight-normal">
          {{ $t('appointment_canceled.confirm_info') }}
        </div>

        <button
          type="button"
          class="btn btn-lg btn-primary btn-block my-3 action-button"
          @click="confirmCancellation"
        >
          {{ $t('appointment_canceled.confirm_button') }}
        </button>

        <a class="btn btn-lg btn-outline-primary btn-block action-button" @click.prevent="keepAppointment">
          {{ $t('appointment_canceled.keep_button') }}
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay';
import {mapActions}   from 'vuex';

export default {
  name: 'AppointmentCanceledView',
  components: {LoadingOverlay},
  props: {
    code: {type: String, default: null},
  },
  data() {
    return {
      loading: false,
      canceled: false,
    };
  },
  methods: {
    ...mapActions({
      cancelAppointment: 'Api/Appointments/cancel',
    }),
    confirmCancellation() {
      this.loading = true;

      this.cancelAppointment({
        booking_code: this.code,
      })
          .then(() => {
            this.canceled = true;
          })
          .catch(this.$apiErrorHandler)
          .finally(() => {
            this.loading = false;
          });
    },
    keepAppointment() {
      this.$router.push('/').catch(console.error);
    },
    bookAnotherAppointment() {
      this.$router.push('/online-appointment').catch(console.error);
    },
  },
};
</script>
